import React from 'react';

interface CountryFlagProps {
  code: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({ code }) => {
  if (!code) return null;

  return (
    <div
      className="inline-block mr-2 align-middle"
      style={{
        width: '17px',
        height: '12px',
        backgroundImage: `url(https://www.benzinga.com/wp-content/themes/benzinga-money/dist/rebuild/images/icons/countries-flags/alpha3/${code}.svg)`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    />
  );
};

export default CountryFlag;
